<template>
  <div class="CorpInfo">
    <!-- 当前位置 -->
    <div class="container">
      <div class="content" >
        <div class="sys">
        <h1>公司部门设置</h1>
         <p>生产科（86913691）、抄表收费科（86912155）、办公室（86913095）、财务科（包括收费服务大厅、86913642）、劳务科（施工抢修队）、供水运行科（供水厂站运行）。</p>
        <h1>下属供水厂站</h1>
          <p>城区配水厂、第二自来水厂、张卜农村集中供水站、皇渠湾农村集中供水站。</p>
          <p>1、城区配水厂（86919359）供水能力1.8万m³/日，供水范围为高陵城区及周边9个行政村，供水人口约10万人。</p>
          <p>2、第二水厂（86080255）供水能力0.5万m³/日，供水范围为泾河工业园北区部分区域，供水人口5万人。</p>
          <p>3、张卜供水站（86054318）供水能力0.14万m³/日，供水范围涉及张卜街道8个行政村、鹿苑街道3个行政村，约7000户居民。</p>
          <p>4、皇渠湾供水站（86075330）供水能力0.3万m³/日，供水范围涉及通远街道10个行政村、姬家街道1个行政村，约7000户居民。</p>
        </div>
      
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created(){
  },
  methods:{
getSys(){
  this.Api.getSys().then((res)=>{
    if(res.code == 0){
      console.log(res);
      this.list=res.data
    }
  })
}
  },
  data(){
    return{
      // 系统列表
list:[]
    }
  },

};
</script>



<style lang="less" scoped>
p {
  color: #666666;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 25px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 6px;
}
h4 {
  color: #333333;
  font-size: 18px;
}
.CorpInfo {
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}

.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #dd2126;
}

.top {
  margin-top: 24px;
  margin-bottom: 30px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #dd2126;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  line-height: 34px;
  color: white;
}
.content {
  width: 1200px;
  min-height: 420px;
  background-color: white;
  box-sizing: border-box;
  padding: 26px 40px;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
.er{
  width: 920px;
overflow-wrap: break-word;
}
</style>